module.exports = __webpack_public_path__ + "img/vivo.4bcbd9e3.svg";